import { useToast } from "@chakra-ui/react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { CircleCheck, CircleAlert, Info } from "lucide-react";

const VARIANTS = {
  success: { bg: "green.500", icon: CircleCheck },
  error: { bg: "red.500", icon: CircleAlert },
  warning: { bg: "orange.500", icon: CircleAlert },
  info: { bg: "blue.500", icon: Info },
};

export function useAppToast() {
  const toast = useToast();

  return (options) => {
    const { title, description, status = "info", duration = 4000, ...rest } = options;
    const variant = VARIANTS[status] || VARIANTS.info;
    const Icon = variant.icon;

    return toast({
      duration,
      position: "bottom",
      render: ({ onClose }) => (
        <Flex
          bg={variant.bg}
          color="white"
          rounded={description ? "xl" : "full"}
          px={6}
          py={3}
          align="center"
          gap={3}
          shadow="lg"
          cursor="pointer"
          onClick={onClose}
          justify="center"
          mx="auto"
          w="fit-content"
        >
          <Box as={Icon} boxSize={5} flexShrink={0} aria-hidden="true" />
          <Flex direction="column">
            <Text fontSize="md" fontWeight={600} lineHeight="short">
              {title}
            </Text>
            {description && (
              <Text fontSize="sm" lineHeight="short" mt={1}>
                {description}
              </Text>
            )}
          </Flex>
        </Flex>
      ),
      ...rest,
    });
  };
}
